// extracted by mini-css-extract-plugin
export var actions = "_kq-d";
export var benefitCard = "_kq-a";
export var benefitIcon = "_kq-b";
export var benefitLabel = "_kq-c";
export var benefits = "_kq-9";
export var bodyText = "_kq-8";
export var closeButton = "_kq-2";
export var content = "_kq-3";
export var eyebrow = "_kq-4";
export var heading = "_kq-5";
export var image = "_kq-f";
export var imagePanel = "_kq-e";
export var modal = "_kq-0";
export var shell = "_kq-1";
export var title = "_kq-6";
export var titleOffer = "_kq-7";